export const convertDateFormate = (date) => {
    if (date) {
        const [year, month] = date?.split('-');
        return { year: parseInt(year, 10), month: parseInt(month, 10) };
    }
    else {
        return { year: null, month: null }
    }
}